import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CreateEventInputDto } from "../../../models/event/dto/create-event.dto";
import { EventDto } from "../../../models/event/dto/event.dto";
import { GET_EVENT_QUERY_KEY } from "./useGetEvent";
import { GET_EVENTS_QUERY_KEY } from "./useListEvents";

export const useCreateEvent = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['createEvent'],
        mutationFn: (dto: CreateEventInputDto) => client.fetchApi<EventDto, CreateEventInputDto>({ endpoint: 'events', method: 'POST', body: dto }),
        onSuccess: (data, variables) => {
            // If it's a recurring event (batch creation), invalidate all event queries
            // to fetch the complete list from the server
            if (variables.isRecurring) {
                queryClient.invalidateQueries({ queryKey: GET_EVENTS_QUERY_KEY(variables.locationId, 'future') });
            } else {
                // For single events, update the cache directly
                queryClient.setQueryData(GET_EVENT_QUERY_KEY(data.id), () => data);
                queryClient.setQueryData(GET_EVENTS_QUERY_KEY(data.organizationLocation.id, 'future'), (prevList: EventDto[]) => {
                    return [...(prevList||[]), data].sort((a, b) => {
                        return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
                    });
                });
            }
        }
    });
};